import Layout from '@layout/Index'

export const clbProductCategory = [
  {
    path: '/clb-product-category',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "clb-product-category-table" */ './pages/ClbProductCategoryTable.vue'),
        meta: {
          title: '查理宝任务分类列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "clb-product-category-form" */ './pages/ClbProductCategoryForm.vue'),
        meta: {
          title: '添加查理宝任务分类',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "clb-product-category-form" */ './pages/ClbProductCategoryForm.vue'),
        meta: {
          title: '修改查理宝任务分类',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "clb-product-category-detail" */ './pages/ClbProductCategoryDetail.vue'),
        meta: {
          title: '查理宝任务分类详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/clb-product-category/clb-product-category.route.js